import React from 'react';
import './frequency-selector.css';

const FrequencySelector = ({ selectedChoice, onSelectChange, selectedValue }) => {
  if (!selectedChoice || !selectedChoice.select) {
    return null;
  }
  
  const value = selectedValue || Object.keys(selectedChoice.select.values)[0];
  
  return (
    <div className="frequency-selector-container">
      <div className="frequency-selector-wrapper">
        <div className="frequency-label">{selectedChoice.select.label}</div>
        <select 
          value={value}
          onChange={(e) => onSelectChange(selectedChoice, e.target.value)}
        >
          {Object.entries(selectedChoice.select.values).map(([value, label]) => (
            <option key={value} value={value}>{label}</option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default FrequencySelector;